import { Theme } from '@material-ui/core';
import { ColorDynamic, VisibilityObserver } from '@superdispatch/ui';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.div(
  ({ theme }: { theme: Theme }) => css`
    &[data-intersecting='false'] {
      left: 0;
      right: 0;
      bottom: 0;
      padding: 16px;
      position: fixed;
      z-index: ${theme.zIndex.modal};
      background-color: ${ColorDynamic.White};
    }
  `,
);

export function StickyAction({ children }: { children: ReactNode }) {
  return (
    <VisibilityObserver
      render={({ ref, visibility }) => (
        <div ref={ref}>
          <Wrapper data-intersecting={visibility === 'visible'}>
            {children}
          </Wrapper>
        </div>
      )}
    />
  );
}
